export enum ImageAuthBlockEnum {
  Desktop = 'desktop',
  Tablet = 'tablet',
  Mobile = 'mobile',
}
